import PipelineTab from './pipeline-tab';
import PipelineImgList from './pipeline-imgList';
import PipelineBrand from './pipeline-brand';
import PipelineFreeSubsidy from './pipeline-free-subsidy';
import PipelineGoodsHorizontal from './pipeline-goodsHorizontal';
import PipelineGoodsRecommend from './pipeline-goodsRecommend'
import PipelineHotspots from './pipeline-hotspots'
import PipelineProductCustomize from './pipeline-productCustomize';
import PipelineRecommend from './pipeline-recommend';
import PipelineRecommendTopGoods from './pipeline-recommendTopGoods';
import PipelineCashBackAct from './pipeline-cashBackAct';
import PipelineCashBackActNew from './pipeline-cashBackActNew';
import PipelineImgs from './pipeline-imgs';
import PipelineNavBar from './pipeline-navBar';
import PipelineProductList from './pipeline-productList';
import PipelineRankList from './pipeline-rankList';
import PipelineSubsidyList from './pipeline-subsidyList';
import PipelineImgListScroll from './pipeline-imgListScroll';
import PipelineSuctionBottomBtns from './pipeline-suctionBottomBtns';
import PipelineSquare from './pipeline-square';
import PipelineSpikeProduct from './pipeline-spikeProduct';
import PipelineGames from './pipeline-games';
import PipelineModal from './pipeline-modal';
import PipelineBtnRadioText from './pipeline-btnRadioText'

export default {
  'pipeline-tab': PipelineTab,
  'pipeline-imgList': PipelineImgList,
  'pipeline-brand': PipelineBrand,
  'pipeline-free-subsidy': PipelineFreeSubsidy,
  'pipeline-goodsHorizontal': PipelineGoodsHorizontal,
  'pipeline-goodsRecommend': PipelineGoodsRecommend,
  'pipeline-hotspots': PipelineHotspots,
  'pipeline-productCustomize': PipelineProductCustomize,
  'pipeline-recommend': PipelineRecommend,
  'pipeline-recommendTopGoods': PipelineRecommendTopGoods,
  'pipeline-cashBackAct': PipelineCashBackAct,
  'pipeline-cashBackActNew': PipelineCashBackActNew,
  'pipeline-imgs': PipelineImgs,
  'pipeline-navBar': PipelineNavBar,
  'pipeline-productList': PipelineProductList,
  'pipeline-rankList': PipelineRankList,
  'pipeline-subsidyList': PipelineSubsidyList,
  'pipeline-imgListScroll': PipelineImgListScroll,
  'pipeline-suctionBottomBtns': PipelineSuctionBottomBtns,
  'pipeline-square': PipelineSquare,
  'pipeline-spikeProduct': PipelineSpikeProduct,
  'pipeline-games': PipelineGames,
  'pipeline-modal': PipelineModal,
  'pipeline-btnRadioText': PipelineBtnRadioText
}


// WEBPACK FOOTER //
// ./components/luodiye.js